import { type Database } from "@fitness-app/supabase";

export type CustomerFeatureEntity = Database["public"]["Tables"]["customer_feature"]["Row"];

export enum CustomerFeatureAccessType {
  Public = "public",
  Private = "private",
  ProductLimited = "product_limited",
}

export enum CustomerFeatureStatus {
  Enabled = "enabled",
  Disabled = "disabled",
  Maintenance = "maintenance",
}

export enum CustomerFeatureName {
  AiNutritionReport = "ai_nutrition_report",
  AiAnalyzer = "aiAnalyzer",
}

export interface CustomerFeatureBase extends Omit<CustomerFeatureEntity, "metadata"> {
  metadata: null | Record<string, string | number | boolean | null>;
  type: CustomerFeatureAccessType;
  feature: CustomerFeatureName;
}

export type CustomerFeature = CustomerFeatureBase;
